import React from 'react';
import { hydrate } from 'react-dom';
import HeaderScaffold from '../app/scaffold/Header';
import getInitialData from './getInitialData';

const loadInitialState = async () => {
  try {
    const initialState = await getInitialData();
    const headerAppEl = document.getElementById('root');

    if (headerAppEl) {
      hydrate(<HeaderScaffold initialState={initialState} />, headerAppEl);
      // eslint-disable-next-line no-underscore-dangle
      window.__PRELOADED_STATE__ = initialState;
    }
  } catch (err) {
    console.error(`Error hydrating application ${err}`);
  }
};

document.addEventListener('DOMContentLoaded', loadInitialState);
